import React, {useMemo} from 'react';
import {t} from "../../../../../../../components/Translate";
import BarsChart from "../../../../../../../components-new/general/charts/BarsChart";
import useChartPalette from "../../../../../../../components-new/general/charts/palette";

/*
 * Categories, tallest first and read down the side.
 *
 * A category is named by whoever created it and the names run long; under the
 * bars they were cut off, which left a chart of anonymous columns. Sorted too,
 * because the question asked of this chart is always which category is busiest.
 *
 * The unnamed row is left out. It arrives with a blank name and draws a bar
 * with nothing beside it, which reads as a rendering fault rather than as a
 * category - and there is nothing to say about it that the chart could show.
 */
const CategoriesStatistics = ({categoriesStatisticsData, user}) => {
    const palette = useChartPalette();

    const rows = useMemo(
        () => (categoriesStatisticsData || [])
            .filter(item => item && item.name && String(item.name).trim() !== '')
            .map(item => ({
                name: item.name,
                // the endpoint stringifies everything on its way out
                count: Number(item.count) || 0,
                color: palette.series2,
            }))
            .sort((a, b) => b.count - a.count),
        [categoriesStatisticsData, palette]
    );

    return (
        <div className="chart-row" style={{marginBottom: 0}}>
            <BarsChart
                data={rows}
                series={[{key: 'count', name: t({text: 'allRequests', user})}]}
                layout="vertical"
                categoryWidth={170}
                height={Math.max(260, Math.min(rows.length * 34 + 40, 560))}
            />
        </div>
    );
};

export default CategoriesStatistics;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/statistics/components/graphs/CategoriesStatistics.jsx